
import Vue from "vue";

import ImageSizePicker, {SupportedFormat} from "./image-size-picker.vue";

export const defaultIOSOutputFormatOptions: SupportedFormat[] = [
  { key: 'auto', name: "Auto", description: "Auto - pdf/svg, png or jpg" },
  { key: 'png', name: "PNG", description: "PNG - rasterize vector images" },
  { key: 'jpg', name: "JPEG", description: "JPEG - rasterize vector images" },
];

export default Vue.extend({
  name: "ios-image-size-picker",
  components: { ImageSizePicker },
  props: {
    sizes: {
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
  data() {
    return {
      outputFormatOptions: defaultIOSOutputFormatOptions
    };
  }
})
